function flash() {
  setTimeout(function () {
    $(".alert").fadeOut(500)
  }, 3000)
}

$(document).ready(flash)
